import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { Dashboard, Widget } from "../models/dashboard.model";
import { SnackService } from "app/shared/services/snack-service.service";
import { TypeDashboard } from "../enums/dashboard-type.enum";
import { map } from "rxjs";
import { safeFirstValueFrom } from "../../../shared/utils/safe-first-value-from";

@Injectable({
  providedIn: "root",
})
export class DashboardApiService {
  constructor(
    private http: HttpClient,
    private snackService: SnackService,
  ) {}

  setMobileIndex(widgets: Widget[]) {
    const widgetsWithIndex = widgets.filter(
      (widget) =>
        widget.mobileIndex !== null && widget.mobileIndex !== undefined,
    );
    widgetsWithIndex.sort((a, b) => a.mobileIndex - b.mobileIndex);
    let currentIndex = 0;
    return widgets.map((widget) => {
      if (widget.mobileIndex === null || widget.mobileIndex === undefined) {
        while (widgetsWithIndex.some((w) => w.mobileIndex === currentIndex)) {
          currentIndex++;
        }
        widget.mobileIndex = currentIndex;
        currentIndex++;
      }
      return widget;
    });
  }

  loadDashboard(type: TypeDashboard) {
    return this.http
      .get<Dashboard>(`${environment.api()}/dashboard/type/${type}`)
      .pipe(
        map((dashboard) => {
          return {
            ...dashboard,
            widgets: this.setMobileIndex(dashboard.widgets),
          };
        }),
      );
  }

  saveGlobalDashboard(dashboard: Dashboard) {
    return this.http.post(`${environment.api()}/dashboard/global`, dashboard);
    //this.snackService.info('Dashboard sauvegardé');
  }

  saveDashboard(dashboard: Dashboard) {
    return this.http.post(`${environment.api()}/dashboard/for_user`, dashboard);
  }

  loadDashboardGlobal(type: TypeDashboard) {
    return this.http
      .get<Dashboard>(`${environment.api()}/dashboard/global/type/${type}`)
      .pipe(
        map((dashboard) => {
          return {
            ...dashboard,
            widgets: this.setMobileIndex(dashboard.widgets),
          };
        }),
      );
  }

  async updateWidget(widget: Widget) {
    return await safeFirstValueFrom(
      this.http.put<Widget>(
        `${environment.api()}/widget/id/${widget.id}`,
        widget,
      ),
    );
  }

  async removeDashboard(id: string) {
    return await safeFirstValueFrom(
      this.http.delete<Dashboard>(`${environment.api()}/dashboard/id/${id}`),
    );
  }
}
